import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoCompressorConfig } from '@/data/landingConfig/landingVideoCompressorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoCompressor } from './schemaObject';

interface Props {}
const VideoCompressor: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoCompressor} />
			<VideoLandingTemplate
				data={landingVideoCompressorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoCompressor()}
			/>
		</>
	);
};

export default VideoCompressor;
